import React from 'react';
import styled from 'astroturf/react';

import routes from 'js/core_pre_webpack/routes';
import trackClick from 'js/utils/trackClick';

const TRIGGER = 'nav-bar--account-avatar-upsell';

// Small additive "Upgrade" affordance that rides the account avatar button for
// non-premium users (autotest `accountAvatarUpsell` surface, arm
// v_account_avatar_upsell). The badge anchors to the top-right of the avatar
// button, which is positioned relative by its parent.
const UpgradeBadge = styled.a`
  position: absolute;
  top: -8px;
  right: -8px;
  z-index: 1;
  display: inline-flex;
  align-items: center;
  padding: 1px 6px;
  border-radius: var(--border-radius-radius-lg, 999px);
  background: var(--brand-colors-blue, #0645b1);
  color: var(--text-inverse, #ffffff);
  font-size: 10px;
  font-weight: 600;
  line-height: 14px;
  letter-spacing: 0.02em;
  white-space: nowrap;

  &:hover,
  &:active,
  &:visited,
  &:focus {
    color: var(--text-inverse, #ffffff);
    text-decoration: none;
  }
`;

const AccountAvatarUpsellBadge = () => {
  const href = routes.upgrade_url({
    feature: 'default',
    from_navbar: true,
    trigger: TRIGGER,
  });

  return (
    <UpgradeBadge
      href={href}
      // Avoid toggling the account menu when the badge itself is clicked.
      onClick={(event) => {
        event.stopPropagation();
        trackClick({ source: TRIGGER });
      }}
    >
      Upgrade
    </UpgradeBadge>
  );
};

export default AccountAvatarUpsellBadge;
